import { PromptStepSchema } from '@feedyou-ai/feedbot-schema'

import { Search } from '../../../types'
import { searchInAnswer } from '../../../Question/stepService/services/search'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<PromptStepSchema> = (step, query) => {
  const directResults = searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      text: [
        'prompt',
        'promptMale',
        'promptFemale',
        'retryPrompt',
        'condition',
        'defaultAnswer.condition'
      ],
      storage: ['storage', 'defaultAnswer.value', 'defaultAnswer.storages.%key%.storage'],
      dialog: ['validator.validDialog', 'validator.invalidDialog', 'defaultAnswer.dialog']
    })
  )

  const answerResults = step.answers?.flatMap(answer => searchInAnswer(answer, query)) ?? []

  return [...directResults, ...answerResults]
}
